/* >>> THIS FILE GOES IN EDIT CODE > ASSETS AS wdf-finder.js <<< (the homepage diet finder engine)
   2026-11-01: the age question is one "How old are they?" picker in months, in line with the
   birthday system (the Puppy / Adult / Senior chips are retired), and window.wdffFinder lets the
   section's scripts read the answers, set the age and run the plan again. Feeding math unchanged.
   2026-11-01b: the result honours and offers the feeding share (All of it / Half / A topper),
   shared with the product pages and the cart drawer. */
(function() {
  "use strict";
  var CFG = {
      DATA_URL_FALLBACK: "",
      RX_TYPES: ["freshrx"],
      DIET_COLORS: {
        "beef + potato": {
          swatch: "#F14450",
          wash: "#F8B5AC"
        },
        "chicken + rice": {
          swatch: "#FBC51B",
          wash: "#FCE698"
        },
        "lamb + egg": {
          swatch: "#70D0D9",
          wash: "#C7EAE0"
        },
        "turkey + sweet potato": {
          swatch: "#F46B34",
          wash: "#FAC4A1"
        },
        "venison + squash": {
          swatch: "#5BC587",
          wash: "#BFE6C1"
        },
        "allergy + skin": {
          swatch: "#B789CB",
          wash: "#E2CFDA"
        },
        cardiac: {
          swatch: "#C93159",
          wash: "#E9AEAF"
        },
        digestive: {
          swatch: "#81D0BF",
          wash: "#CEEAD6"
        },
        "lf digestive": {
          swatch: "#F57965",
          wash: "#FAC9B4"
        },
        hepatic: {
          swatch: "#D3B09F",
          wash: "#EDDECA"
        },
        renal: {
          swatch: "#78C072",
          wash: "#CAE4B9"
        },
        "lf renal": {
          swatch: "#D1953C",
          wash: "#ECD4A4"
        },
        urinary: {
          swatch: "#5C9CA5",
          wash: "#B4D2DE"
        },
        "weight + mobility": {
          swatch: "#4EAE96",
          wash: "#BADDC6"
        }
      },
      DIET_COLOR_DEFAULT: {
        swatch: "#C9C4B0",
        wash: "#E4E0D2"
      },
      PRODUCT_BASE: "/products",
      DAYS_PER_WEEK: 7,
      PACKETS: [{
        oz: 64,
        key: "64"
      }, {
        oz: 16,
        key: "16"
      }],
      CART_SOURCE: "Diet Finder",
      CART_ADD_URL: "/cart/add",
      CART_GET_URL: "/cart",
      OPEN_MINICART: !0,
      ROUND_OZ_DAY: .25,
      ROUND_OZ_MEAL: .25,
      ROUND_CUP_DAY: 4,
      ROUND_CUP_MEAL: 8,
      LB_PER_KG: 2.2046226218,
      G_PER_OZ: 28.349523125,
      NEVER_RECOMMEND: ["hepatic", "renal", "lf renal", "urinary"],
      CONDITION_ONLY: ["allergy + skin", "cardiac", "digestive", "lf digestive"],
      PUPPY_ELIGIBLE_RX: ["digestive"],
      BODY_GATED: {
        "weight + mobility": ["over"]
      },
      DENSITY_WEIGHT: 1.6,
      DENSITY_PIVOT: 1200,
      DENSITY_PIVOT_SPREAD: 200,
      OVER_REFERENCE: 1500,
      UNDER_REFERENCE: 950,
      BONUS: {
        over: [
          ["crude_fiber", 6, 2.5, "fiber"],
          ["protein", 100, 1.5, "protein_lean"],
          ["kcal_per_cup", 200, 1, "bowl_full"]
        ],
        under: [
          ["fat", 50, 2, "dense_fat"],
          ["kcal_per_kg", 1400, 1, "most_dense"]
        ],
        puppy: [
          ["calcium", 3.2, .75, "calcium"],
          ["protein", 100, .5, "protein_growth"]
        ],
        senior: [
          ["protein", 100, 1, "protein_senior"],
          ["epa_plus_dha", .7, .75, "omega"]
        ],
        high: [
          ["fat", 50, 1.5, "fat_active"],
          ["protein", 100, 1, "protein_recovery"]
        ]
      },
      DENSITY_CAP_UNDER: 1300,
      ALT_COUNT: 2,
      SPLIT_3_CUPS: 8,
      TRANSITION: [{
        days: "Days 1 - 3",
        pct: 25
      }, {
        days: "Days 4 - 6",
        pct: 50
      }, {
        days: "Days 7 - 9",
        pct: 75
      }, {
        days: "Day 10 +",
        pct: 100
      }],
      WEIGHT_BANDS: [
        [2, 10, .5],
        [10, 30, 1],
        [30, 70, 1],
        [70, 120, 2],
        [120, 180, 5]
      ],
      WEIGHT_MIN: 2,
      WEIGHT_MAX: 180,
      WEIGHT_DEFAULT: 45,
      AGE_MONTHS_MIN: 2,
      AGE_YEARS_MAX: 20,
      AGE_DEFAULT: null,
      SHARES: [100, 50, 25],
      SHARES_RX: [100, 50],
      BODY_DEFAULT: "ideal",
      ACT_DEFAULT: null,
      BODY_OPTS: [{
        id: "under",
        label: "Ribs showing",
        sub: "Could gain a little"
      }, {
        id: "ideal",
        label: "Just right",
        sub: "Waist you can see"
      }, {
        id: "over",
        label: "Carrying extra",
        sub: "No clear waist"
      }],
      ACTIVITY_OPTS: [{
        id: "low",
        label: "Couch potato"
      }, {
        id: "normal",
        label: "Daily walks"
      }, {
        id: "high",
        label: "Always going"
      }],
      SCROLL_GAP: 62,
      SCROLL_FALLBACK_HEADER: 150,
      SCROLL_HEADER_SELECTORS: ["#shopify-section-header", ".shopify-section-header-sticky", "header", ".header", ".site-header", "#header", ".announcement-bar", "[data-sticky-header]"],
      RX_FINDER_URL: "/collections/shop-all#rx",
      VET_LOCATOR_URL: "/pages/veterinary-partner-locator",
      CALCULATOR_URL: "/pages/feeding-calculator"
    },
    COPY = {
      q_weight: "How much do they weigh?",
      q_age: "How old are they?",
      q_body: "What&rsquo;s their build?",
      q_act: "How active are they?",
      age_pick: "Pick their age",
      por_label: "Wynwood will be",
      por_group: "How much of their food is Wynwood",
      por_100: "All of it",
      por_50: "Half",
      por_25: "A topper",
      portion_key_share: "Wynwood per day",
      por_of_50: "That is half of the {full} calories they need a day. Their usual food makes up the rest.",
      por_of_25: "That is a quarter of the {full} calories they need a day. Their usual food makes up the rest.",
      age_month1: "1 month",
      age_months: "{n} months",
      age_year1: "1 year",
      age_years: "{n} years",
      cond_check: "My dog has a diagnosed health condition",
      go: "Get their plan",
      go_hint: "Answer all four to continue",
      rx_eyebrow: "Let&rsquo;s get a vet involved",
      rx_head: "This one needs a prescription.",
      rx_body: "Dogs with a diagnosed condition need a diet chosen for that condition, not for their build. Our Fresh Rx&reg; line covers kidney, liver, heart, digestive, urinary, skin, and weight conditions, but the right one depends on the diagnosis.",
      rx_cta_1: "See Fresh Rx diets",
      rx_cta_2: "Find a vet partner",
      rx_back: "&larr; Back to the questions",
      result_redo: "&larr; Start over",
      tag_complete: "Complete &amp; Balanced",
      tag_freshrx: "Fresh Rx&reg;",
      portion_key: "Feed per day",
      alts_key: "Also a good fit",
      alt_link: "View diet &rarr;",
      shop: "Shop this diet",
      reduction_tip: "{diet} is shown at a {pct}% reduction from your dog&rsquo;s maintenance requirement. It is formulated for weight management, so it is fed slightly below maintenance to take weight off gradually. Your veterinarian may set a different target based on your dog&rsquo;s goal weight.",
      rx_note: "<strong>Fresh Rx&reg; requires veterinary recommendation.</strong> Talk to your veterinarian before starting or switching a therapeutic diet, and have them confirm the portion for your dog.",
      head_over: "At {kg} kcal/kg this is one of our least calorie-dense recipes, so they get a full bowl while eating fewer calories.",
      head_under: "At {kg} kcal/kg this is a calorie-forward recipe, so a leaner dog can put weight back on without needing a bigger bowl.",
      head_senior: "Built around the protein and omega-3s that matter most for keeping an older dog moving well.",
      head_puppy: "A growth-friendly everyday recipe, with the calcium and protein that help a puppy build frame.",
      head_default: "A balanced everyday recipe that sits right in the middle on calories, so it&rsquo;s easy to feed and easy to keep them steady on.",
      reason: {
        fiber: "Extra fiber ({v}g per 1,000 kcal) keeps them feeling full on fewer calories",
        protein_lean: "High protein ({v}g) protects muscle while they lose fat",
        bowl_full: "Less energy per cup, so the bowl still looks full",
        dense_fat: "Calorie-dense at {v}g fat per 1,000 kcal, so more energy in less food",
        most_dense: "{v} kcal/kg is our most concentrated recipe",
        calcium: "Calcium at {v}g supports growing bone",
        protein_growth: "High protein for building a body",
        protein_senior: "High protein ({v}g) fights age-related muscle loss",
        omega: "Omega-3s at {v}g support stiff joints",
        fat_active: "Higher fat fuels a dog that never sits down",
        protein_recovery: "Protein for muscle recovery"
      },
      split_2: "Split across two meals: about <strong>{v} {unit}</strong> morning and night.",
      split_3: "Split across three meals: about <strong>{v} {unit}</strong> each.",
      trans_sum: "Switching from another food? Here&rsquo;s the 10-day plan",
      trans_head: ["Days", "Old food", "Wynwood", "Oz/day", "Cups/day"],
      trans_fine: "Go slower if their stomach is sensitive. There&rsquo;s no prize for rushing it.",
      cart_add: "Add a week of food",
      cart_adding: "Adding&hellip;",
      cart_added: "Added to cart",
      cart_err: "Couldn&rsquo;t add that. Try again?",
      calc_link: "Need a different diet or portion? Use the full feeding calculator",
      fine: "A starting point, not a prescription. Every dog runs a little different, so check their weight after a few weeks and adjust. Puppies, pregnant dogs, and any dog under treatment should be fed on your vet&rsquo;s advice.",
      err_load: 'Couldn&rsquo;t load our diet data just now. You can still <a href="' + CFG.CALCULATOR_URL + '">use the feeding calculator</a>.',
      err_admin: "<strong>Diet Finder: data didn&rsquo;t load.</strong> {reason}<br>Check the <code>wdff_data</code> URL at the top of this Custom Liquid block. Re-uploading diets.json to Content &gt; Files creates a new URL, so an older one stops working.",
      loading: "Getting the diets&hellip;"
    },
    $ = function(id) {
      return document.getElementById(id)
    };

  function fill(str, map) {
    return String(str).replace(/\{(\w+)\}/g, function(m, k) {
      return map[k] == null ? m : map[k]
    })
  }

  function esc(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  }

  function dietTitle(key) {
    return String(key).replace(/\b[a-z]/g, function(c) {
      return c.toUpperCase()
    }).replace(/\bLf\b/, "LF")
  }

  function dietColor(key) {
    return CFG.DIET_COLORS[key] || CFG.DIET_COLOR_DEFAULT
  }

  function colorVars(key) {
    var c = dietColor(key);
    return ' style="--card:' + c.wash + ";--swatch:" + c.swatch + '"'
  }

  function buildLadder() {
    var out = [],
      i, b, v;
    for (i = 0; i < CFG.WEIGHT_BANDS.length; i++)
      for (b = CFG.WEIGHT_BANDS[i], v = b[0]; v < b[1]; v += b[2]) out.push(Math.round(v * 100) / 100);
    return out.push(CFG.WEIGHT_MAX), out
  }
  var LADDER = buildLadder();

  function weightToIndex(w) {
    var best = 0,
      bd = 1 / 0,
      i, d;
    for (i = 0; i < LADDER.length; i++) d = Math.abs(LADDER[i] - w), d < bd && (bd = d, best = i);
    return best
  }

  function roundTo(v, inc) {
    return window.wynFeed.roundTo(v, inc)
  }

  function fmtOz(v, inc) {
    return window.wynFeed.fmtOz(v, inc || CFG.ROUND_OZ_DAY)
  }

  function fmtCups(v, den) {
    return window.wynFeed.fmtCups(v, den || CFG.ROUND_CUP_DAY)
  }

  function cupWord(v) {
    return v >= 2 ? "cups" : "cup"
  }

  function num(v, dp) {
    dp = dp == null ? 1 : dp;
    var r = Math.round(v * Math.pow(10, dp)) / Math.pow(10, dp);
    return String(r)
  }

  function money(cents) {
    return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "")
  }

  /* AGE IS IN MONTHS (2026-11-01). The Puppy / Adult / Senior chips are
     retired with the birthday system: the answer is one age, and every rule
     below reads months from here. Unanswered falls back to 48, as before. */
  function ageMonths() {
    var m = Number(state.age);
    return state.age != null && isFinite(m) && m > 0 ? m : 48
  }

  function ageOptions() {
    var out = [],
      m, y;
    for (m = CFG.AGE_MONTHS_MIN; m < 12; m++) out.push([m, m === 1 ? COPY.age_month1 : fill(COPY.age_months, {
      n: m
    })]);
    for (y = 1; y <= CFG.AGE_YEARS_MAX; y++) out.push([y * 12, y === 1 ? COPY.age_year1 : fill(COPY.age_years, {
      n: y
    })]);
    return out
  }

  /* the option a month count belongs to: whole months under a year, whole
     years after, so a birthday-derived 9.6 years shows as 9 years and lands in
     the same feeding band it came from */
  function ageOptionFor(months) {
    var m = Number(months);
    if (!isFinite(m) || m < 0) return null;
    if (m < 12) return Math.max(CFG.AGE_MONTHS_MIN, Math.floor(m));
    return Math.min(CFG.AGE_YEARS_MAX, Math.floor(m / 12)) * 12
  }

  function planFor(key, diet) {
    diet = diet || {};
    return window.wynFeed.plan({
      weight_lb: state.weight,
      ageMonths: ageMonths(),
      activity: state.act
    }, {
      key: key,
      kcal_per_kg: diet.kcal_per_kg,
      kcal_per_cup: diet.kcal_per_cup
    })
  }

  /* THE FEEDING SHARE (2026-11-01). The same "Wynwood will be All of it / Half
     / A topper" the product pages ask, read from and saved to the same shared
     dog profile, so the finder, the product pages and the cart drawer always
     agree. A Fresh Rx diet offers All or Half only, as its product page does:
     a quarter of a therapeutic diet is not the diet. */
  function savedShare() {
    var p = null;
    try {
      var g = window.wynProfile && window.wynProfile.get ? window.wynProfile.get() : null;
      p = g ? Number(g.portion) : Number((JSON.parse(localStorage.getItem("wyn_dog") || "{}") || {}).portion)
    } catch (e) {}
    return CFG.SHARES.indexOf(p) !== -1 ? p : 100
  }

  function sharesFor(diet) {
    return CFG.RX_TYPES.indexOf(diet && diet.type) !== -1 ? CFG.SHARES_RX : CFG.SHARES
  }

  function shareFor(diet) {
    var s = savedShare();
    return sharesFor(diet).indexOf(s) !== -1 ? s : 100
  }

  function shareHTML(diet, share, fullKcal) {
    var h = '<div class="wdff-por"><p class="wdff-por__l">' + COPY.por_label + '</p><div class="wdff-por__g" role="group" aria-label="' + COPY.por_group + '">';
    sharesFor(diet).forEach(function(v) {
      h += '<button type="button" class="wdff-por__b" data-por="' + v + '" aria-pressed="' + (v === share ? "true" : "false") + '"><span class="wdff-por__i" style="--w:' + 360 * v / 100 + 'deg" aria-hidden="true"><i></i></span><b>' + COPY["por_" + v] + "</b></button>"
    });
    return h + "</div>" + (share < 100 ? '<p class="wdff-por__n">' + fill(COPY["por_of_" + share], {
      full: Math.round(fullKcal).toLocaleString()
    }) + "</p>" : "") + "</div>"
  }

  function maintenanceKcal() {
    return window.wynFeed.plan({
      weight_lb: state.weight,
      ageMonths: ageMonths(),
      activity: state.act
    }, {}).kcalFull
  }

  function dietKcal(key) {
    var d = DB && DB.diets && DB.diets[key] || {},
      p = planFor(key, d);
    return {
      kcal: p.kcal,
      reduction: Math.round(p.reduction)
    }
  }

  function nutrient(diet, key) {
    if (key === "kcal_per_kg") return diet.kcal_per_kg;
    if (key === "kcal_per_cup") return diet.kcal_per_cup;
    var groups = diet.per_1000kcal || {},
      g;
    for (g in groups)
      if (Object.prototype.hasOwnProperty.call(groups, g) && groups[g] && groups[g][key] != null) return groups[g][key];
    return null
  }

  function eligible(key, diet) {
    if (CFG.NEVER_RECOMMEND.indexOf(key) !== -1 || CFG.CONDITION_ONLY.indexOf(key) !== -1) return !1;
    var isRx = CFG.RX_TYPES.indexOf(diet.type) !== -1,
      puppy = ageMonths() < 12;
    if (isRx && puppy && CFG.PUPPY_ELIGIBLE_RX.indexOf(key) === -1) return !1;
    var gate = CFG.BODY_GATED[key];
    return !(gate && gate.indexOf(state.body) === -1)
  }

  function applyBonus(list, diet, score, why) {
    if (!list) return score;
    for (var i = 0; i < list.length; i++) {
      var key = list[i][0],
        thresh = list[i][1],
        pts = list[i][2],
        copyKey = list[i][3],
        v = nutrient(diet, key);
      if (v != null) {
        var hit = key === "kcal_per_cup" ? v <= thresh : v >= thresh;
        if (hit) {
          score += pts;
          var shown = key === "kcal_per_kg" ? Math.round(v).toLocaleString() : key === "epa_plus_dha" ? num(v, 2) : num(v, 1);
          why.push(fill(COPY.reason[copyKey], {
            v: shown
          }))
        }
      }
    }
    return score
  }

  function rank(db) {
    var months = ageMonths(),
      puppy = months < 12,
      senior = months >= 84,
      out = [];
    return Object.keys(db.diets).forEach(function(key) {
      var diet = db.diets[key];
      if (eligible(key, diet)) {
        var s = 0,
          why = [],
          kg = diet.kcal_per_kg;
        if (state.body === "over") s += (CFG.OVER_REFERENCE - kg) / 100 * CFG.DENSITY_WEIGHT, s = applyBonus(CFG.BONUS.over, diet, s, why);
        else if (state.body === "under") {
          var kgUnder = Math.min(kg, CFG.DENSITY_CAP_UNDER);
          s += (kgUnder - CFG.UNDER_REFERENCE) / 100 * CFG.DENSITY_WEIGHT, s = applyBonus(CFG.BONUS.under, diet, s, why)
        } else s += 2 - Math.abs(kg - CFG.DENSITY_PIVOT) / CFG.DENSITY_PIVOT_SPREAD;
        puppy && (s = applyBonus(CFG.BONUS.puppy, diet, s, why)), senior && (s = applyBonus(CFG.BONUS.senior, diet, s, why)), state.act === "high" && (s = applyBonus(CFG.BONUS.high, diet, s, why)), out.push({
          key: key,
          diet: diet,
          score: s,
          why: why
        })
      }
    }), out.sort(function(a, b) {
      return b.score - a.score
    }), out
  }

  function headline(top) {
    var kg = Math.round(top.diet.kcal_per_kg).toLocaleString(),
      months = ageMonths();
    return state.body === "over" ? fill(COPY.head_over, {
      kg: kg
    }) : state.body === "under" ? fill(COPY.head_under, {
      kg: kg
    }) : months >= 84 ? COPY.head_senior : months < 12 ? COPY.head_puppy : COPY.head_default
  }

  function dataURL() {
    var el = document.getElementById("wdff-body"),
      u = el && el.getAttribute("data-diets");
    return u && u.indexOf("PASTE_") === -1 ? u : CFG.DATA_URL_FALLBACK || ""
  }
  var WynwoodDiets = window.WynwoodDiets || (window.WynwoodDiets = (function() {
      var cache = null,
        inflight = null;
      return {
        url: dataURL,
        load: function() {
          if (cache) return Promise.resolve(cache);
          if (inflight) return inflight;
          var url = dataURL();
          return url ? (inflight = fetch(url).then(function(r) {
            if (!r.ok) throw new Error("HTTP " + r.status);
            return r.json()
          }).then(function(json) {
            if (!json || !json.diets) throw new Error("Unexpected file shape");
            return cache = json, inflight = null, json
          }).catch(function(err) {
            throw inflight = null, err
          }), inflight) : Promise.reject(new Error("No diets.json URL set in the section"))
        }
      }
    })()),
    VARIANTS = (function() {
      var el = $("wdff-variants");
      if (!el) return {};
      try {
        return JSON.parse(el.textContent || "{}")
      } catch (e) {
        return {}
      }
    })();

  function packWeek(ozPerDay, key) {
    var v = VARIANTS[key];
    if (!v) return null;
    var ozWeek = ozPerDay * CFG.DAYS_PER_WEEK,
      sizes = CFG.PACKETS.slice().sort(function(a, b) {
        return a.oz - b.oz
      }),
      unit = sizes[0].oz,
      units = Math.ceil(ozWeek / unit - 1e-9),
      packs = [],
      i, per, n;
    for (i = sizes.length - 1; i >= 0; i--) per = sizes[i].oz / unit, n = i === 0 ? units : Math.floor(units / per), n > 0 && (packs.push({
      key: sizes[i].key,
      oz: sizes[i].oz,
      qty: n
    }), units -= n * per);
    var items = [],
      supplied = 0,
      cents = 0,
      ok = !0;
    return packs.forEach(function(pk) {
      var info = v[pk.key];
      if (!info || !info.id || info.available === !1) {
        ok = !1;
        return
      }
      items.push({
        id: info.id,
        qty: pk.qty
      }), supplied += pk.qty * pk.oz, cents += pk.qty * (Number(info.price) || 0)
    }), !ok || !items.length ? null : {
      items: items,
      oz: supplied,
      cents: cents
    }
  }
  var state = {
      weight: CFG.WEIGHT_DEFAULT,
      age: CFG.AGE_DEFAULT,
      body: CFG.BODY_DEFAULT,
      act: CFG.ACT_DEFAULT,
      cond: !1
    },
    DB = null,
    mounted = !1,
    root = $("wdff"),
    body = $("wdff-body");
  if (!root || !body) return;
  if (!window.wynFeed) {
    window.console && console.error("[wdff] wynfeed.js is not loaded. The shared feeding math is missing, so no portion can be shown.");
    body.innerHTML = '<p class="wdff-err">' + COPY.err_load + "</p>";
    return
  }

  function optRow(group, opts, tall, selected) {
    var h = '<div class="wdff-opts' + (tall ? " wdff-opts--tall" : "") + '" role="radiogroup" data-group="' + group + '">';
    return opts.forEach(function(o) {
      var on = selected != null && o.id === selected;
      h += '<button type="button" class="wdff-opt' + (tall ? " wdff-opt--tall" : "") + '" data-val="' + o.id + '" role="radio" aria-checked="' + (on ? "true" : "false") + '">', o.sub ? h += '<span class="wdff-opt__t">' + o.label + '</span><span class="wdff-opt__s">' + o.sub + "</span>" : h += o.label, h += "</button>"
    }), h + "</div>"
  }

  function ageSelect() {
    var h = '<div class="wdff-age"><select class="wdff-age__sel" id="wdff-age" required><option value="">' + COPY.age_pick + "</option>";
    return ageOptions().forEach(function(o) {
      h += '<option value="' + o[0] + '"' + (state.age === o[0] ? " selected" : "") + ">" + o[1] + "</option>"
    }), h + "</select></div>"
  }

  function formHTML() {
    return '<div class="wdff-form" id="wdff-form"><div class="wdff-q"><div class="wdff-q__head"><span class="wdff-q__n">1</span><label class="wdff-q__label" for="wdff-weight">' + COPY.q_weight + '</label></div><div class="wdff-weight"><output class="wdff-weight__out" id="wdff-weight-out">' + CFG.WEIGHT_DEFAULT + '<span>lbs</span></output><input type="range" id="wdff-weight" class="wdff-range" min="0" max="' + (LADDER.length - 1) + '" step="1" value="' + weightToIndex(CFG.WEIGHT_DEFAULT) + '" aria-label="Dog weight in pounds"><div class="wdff-weight__ticks"><span>' + CFG.WEIGHT_MIN + "</span><span>" + CFG.WEIGHT_MAX + ' lbs</span></div></div></div><div class="wdff-q"><div class="wdff-q__head"><span class="wdff-q__n">2</span><label class="wdff-q__label" for="wdff-age">' + COPY.q_age + "</label></div>" + ageSelect() + '</div><div class="wdff-q"><div class="wdff-q__head"><span class="wdff-q__n">3</span><span class="wdff-q__label">' + COPY.q_body + "</span></div>" + optRow("body", CFG.BODY_OPTS, !0, CFG.BODY_DEFAULT) + '</div><div class="wdff-q"><div class="wdff-q__head"><span class="wdff-q__n">4</span><span class="wdff-q__label">' + COPY.q_act + "</span></div>" + optRow("act", CFG.ACTIVITY_OPTS, !1, CFG.ACT_DEFAULT) + '</div><div class="wdff-flag"><label class="wdff-check"><input type="checkbox" id="wdff-cond"><span class="wdff-check__box" aria-hidden="true"></span><span class="wdff-check__t">' + COPY.cond_check + '</span></label></div><button type="button" class="wdff-go" id="wdff-go" disabled><span class="wdff-go__t">' + COPY.go + '</span><span class="wdff-go__hint">' + COPY.go_hint + '</span></button></div><div class="wdff-rx" id="wdff-rx" hidden><p class="wdff-rx__eyebrow">' + COPY.rx_eyebrow + '</p><h3 class="wdff-rx__h">' + COPY.rx_head + '</h3><p class="wdff-rx__p">' + COPY.rx_body + '</p><div class="wdff-rx__row"><a class="wdff-btn" href="' + CFG.RX_FINDER_URL + '">' + COPY.rx_cta_1 + '</a><a class="wdff-btn wdff-btn--ghost" href="' + CFG.VET_LOCATOR_URL + '">' + COPY.rx_cta_2 + '</a></div><button type="button" class="wdff-back" id="wdff-rx-back">' + COPY.rx_back + '</button></div><div class="wdff-result" id="wdff-result" hidden></div>'
  }

  function resultHTML(ranked) {
    var top = ranked[0],
      diet = top.diet,
      key = top.key,
      target = dietKcal(key),
      share = shareFor(diet),
      fullKcal = target.kcal,
      kcal = fullKcal * share / 100,
      grams = kcal / diet.kcal_per_kg * 1e3,
      oz = grams / CFG.G_PER_OZ,
      cups = kcal / diet.kcal_per_cup,
      isRx = CFG.RX_TYPES.indexOf(diet.type) !== -1,
      months = ageMonths(),
      meals = months < 12 || fullKcal / diet.kcal_per_cup > CFG.SPLIT_3_CUPS ? 3 : 2,
      perMealCups = cups / meals,
      ageWord = months < 6 ? "puppy" : months < 12 ? "young dog" : months < 84 ? "adult" : "senior",
      bodyWord = state.body === "over" ? "carrying extra weight" : state.body === "under" ? "on the lean side" : "in good shape",
      h = "";
    h += '<div class="wdff-result__head"><p class="wdff-result__eyebrow">' + num(state.weight, 1) + " lb " + ageWord + ", " + bodyWord + '</p><button type="button" class="wdff-back" id="wdff-redo">' + COPY.result_redo + "</button></div>", h += '<div class="wdff-pick"' + colorVars(key) + '><div class="wdff-pick__main"><span class="wdff-pick__tag' + (isRx ? " wdff-pick__tag--rx" : "") + '">' + (isRx ? COPY.tag_freshrx : COPY.tag_complete) + '</span><h3 class="wdff-pick__name">' + esc(dietTitle(key)) + '</h3><p class="wdff-pick__why">' + headline(top) + '</p><ul class="wdff-reasons">', top.why.slice(0, 3).forEach(function(w) {
      h += "<li>" + w + "</li>"
    }), h += "</ul>", diet.handle && (h += '<a class="wdff-btn" href="' + CFG.PRODUCT_BASE + "/" + diet.handle + '">' + COPY.shop + "</a>"), h += "</div>", h += '<div class="wdff-portion"><p class="wdff-portion__k">' + (share < 100 ? COPY.portion_key_share : COPY.portion_key) + '</p><div class="wdff-portion__big"><span class="wdff-portion__v">' + fmtOz(oz, CFG.ROUND_OZ_DAY) + '</span><span class="wdff-portion__u">oz</span></div><div class="wdff-portion__alt">' + fmtCups(cups, CFG.ROUND_CUP_DAY) + " " + cupWord(cups) + '</div><div class="wdff-portion__cal">' + Math.round(kcal).toLocaleString() + " kcal/day" + (target.reduction ? ' <button type="button" class="wdff-ast" id="wdff-ast" aria-label="Why this is reduced">*</button>' : "") + '</div><p class="wdff-portion__note">' + fill(meals === 3 ? COPY.split_3 : COPY.split_2, {
      v: fmtCups(perMealCups, CFG.ROUND_CUP_MEAL),
      unit: cupWord(perMealCups)
    }) + "</p></div></div>", target.reduction && (h += '<p class="wdff-tip" id="wdff-tip" hidden>' + fill(COPY.reduction_tip, {
      diet: esc(dietTitle(key)),
      pct: target.reduction
    }) + "</p>"), isRx && (h += '<p class="wdff-rxnote">' + COPY.rx_note + "</p>");
    h += shareHTML(diet, share, fullKcal);
    var pack = packWeek(oz, key);
    return pack && (h += '<button type="button" class="wdff-cart" id="wdff-cart" data-key="' + esc(key) + '" data-oz="' + oz + '"><span class="wdff-cart__t">' + COPY.cart_add + '</span><span class="wdff-cart__m">' + pack.oz + " oz &middot; " + money(pack.cents) + "</span></button>"), ranked.length > 1 && (h += '<div class="wdff-alts"><p class="wdff-alts__k">' + COPY.alts_key + '</p><ul class="wdff-alts__list">', ranked.slice(1, 1 + CFG.ALT_COUNT).forEach(function(r) {
      var rk = dietKcal(r.key).kcal * shareFor(r.diet) / 100,
        rc = rk / r.diet.kcal_per_cup;
      h += '<li class="wdff-alt"' + colorVars(r.key) + '><div class="wdff-alt__top"><span class="wdff-alt__n">' + esc(dietTitle(r.key)) + '</span><span class="wdff-alt__p">' + fmtCups(rc, CFG.ROUND_CUP_DAY) + " " + cupWord(rc) + '/day</span></div><p class="wdff-alt__why">' + (r.why[0] || Math.round(r.diet.kcal_per_kg).toLocaleString() + " kcal/kg") + "</p>" + (r.diet.handle ? '<a class="wdff-alt__link" href="' + CFG.PRODUCT_BASE + "/" + r.diet.handle + '">' + COPY.alt_link + "</a>" : "") + "</li>"
    }), h += "</ul></div>"), h += '<details class="wdff-trans"><summary class="wdff-trans__sum"><span>' + COPY.trans_sum + '</span><span class="wdff-trans__tog" aria-hidden="true"><span class="wdff-trans__bar wdff-trans__bar--h"></span><span class="wdff-trans__bar wdff-trans__bar--v"></span></span></summary><div class="wdff-trans__body"><table class="wdff-trans__table"><thead><tr>', COPY.trans_head.forEach(function(t) {
      h += "<th>" + t + "</th>"
    }), h += "</tr></thead><tbody>", CFG.TRANSITION.forEach(function(t) {
      var f = t.pct / 100;
      h += "<tr><td>" + t.days + "</td><td>" + (100 - t.pct) + "%</td><td>" + t.pct + '%</td><td><span class="wdff-hl">' + fmtOz(oz * f, CFG.ROUND_OZ_DAY) + " oz</span></td><td>" + fmtCups(cups * f, CFG.ROUND_CUP_DAY) + "</td></tr>"
    }), h += '</tbody></table><p class="wdff-trans__fine">' + COPY.trans_fine + "</p></div></details>", h += '<p class="wdff-calc"><a href="' + CFG.CALCULATOR_URL + '">' + COPY.calc_link + "</a></p>", h += '<p class="wdff-fine">' + COPY.fine + "</p>", h
  }

  function measureHeader() {
    var lowest = 0,
      seen = [],
      i, j, nodes, el, cs, rect;
    for (i = 0; i < CFG.SCROLL_HEADER_SELECTORS.length; i++) {
      try {
        nodes = document.querySelectorAll(CFG.SCROLL_HEADER_SELECTORS[i])
      } catch (e) {
        continue
      }
      for (j = 0; j < nodes.length; j++) el = nodes[j], seen.indexOf(el) === -1 && (seen.push(el), !(root.contains(el) || el.contains(root)) && (cs = window.getComputedStyle ? window.getComputedStyle(el) : null, cs && (cs.position !== "fixed" && cs.position !== "sticky" || cs.display === "none" || cs.visibility === "hidden" || (rect = el.getBoundingClientRect(), !(rect.height < 8 || rect.top > 8) && rect.bottom > lowest && (lowest = rect.bottom)))))
    }
    return lowest > 0 ? lowest : CFG.SCROLL_FALLBACK_HEADER
  }

  function scrollTo(el) {
    if (el) {
      var rect = el.getBoundingClientRect(),
        pageY = rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0),
        target = Math.max(0, pageY - (measureHeader() + CFG.SCROLL_GAP));
      try {
        window.scrollTo({
          top: target,
          behavior: "smooth"
        })
      } catch (e) {
        window.scrollTo(0, target)
      }
    }
  }

  function checkReady() {
    var go = $("wdff-go");
    if (go) {
      var ok = !!(state.age != null && state.body && state.act);
      go.disabled = !ok
    }
  }

  function wireForm() {
    var w = $("wdff-weight"),
      out = $("wdff-weight-out");
    w.addEventListener("input", function() {
      state.weight = LADDER[Number(this.value)] || CFG.WEIGHT_DEFAULT, out.innerHTML = num(state.weight, 1) + "<span>lbs</span>"
    }), Array.prototype.forEach.call(body.querySelectorAll(".wdff-opts"), function(group) {
      var k = group.getAttribute("data-group");
      group.addEventListener("click", function(e) {
        var btn = e.target.closest(".wdff-opt");
        if (btn) {
          Array.prototype.forEach.call(group.querySelectorAll(".wdff-opt"), function(b) {
            b.setAttribute("aria-checked", b === btn ? "true" : "false")
          });
          state[k] = btn.getAttribute("data-val");
          checkReady()
        }
      }), group.addEventListener("keydown", function(e) {
        if (!(e.key !== "ArrowRight" && e.key !== "ArrowLeft")) {
          var btns = Array.prototype.slice.call(group.querySelectorAll(".wdff-opt")),
            i = btns.indexOf(document.activeElement);
          if (i !== -1) {
            e.preventDefault();
            var n = e.key === "ArrowRight" ? (i + 1) % btns.length : (i - 1 + btns.length) % btns.length;
            btns[n].focus(), btns[n].click()
          }
        }
      })
    });
    var ageSel = $("wdff-age");
    ageSel && ageSel.addEventListener("change", function() {
      var v = Number(this.value);
      state.age = this.value !== "" && isFinite(v) && v > 0 ? v : null, checkReady()
    }), $("wdff-cond").addEventListener("change", function() {
      state.cond = this.checked
    }), $("wdff-go").addEventListener("click", function() {
      var form = $("wdff-form"),
        rx = $("wdff-rx"),
        res = $("wdff-result");
      if (state.cond) {
        form.hidden = !0, res.hidden = !0, rx.hidden = !1, scrollTo(rx);
        return
      }
      if (!DB) {
        showError(new Error("Diet data never loaded"));
        return
      }
      var ranked = rank(DB);
      if (!ranked.length) {
        form.hidden = !0, rx.hidden = !1, scrollTo(rx);
        return
      }
      res.innerHTML = resultHTML(ranked), form.hidden = !0, rx.hidden = !0, res.hidden = !1, wireResult(), scrollTo(res)
    }), $("wdff-rx-back").addEventListener("click", function() {
      $("wdff-rx").hidden = !0, $("wdff-form").hidden = !1, scrollTo($("wdff-form"))
    })
  }

  /* run the plan again where the customer is: a share change must not throw
     them back up to the top of the result */
  function rerunQuiet() {
    var go = $("wdff-go");
    if (!go || go.disabled) return;
    var y = window.pageYOffset || 0,
      orig = window.scrollTo;
    window.wdffFinder.rerunning = !0;
    window.scrollTo = function() {};
    try {
      go.click()
    } finally {
      setTimeout(function() {
        window.scrollTo = orig, window.wdffFinder.rerunning = !1, Math.abs((window.pageYOffset || 0) - y) > 2 && orig.call(window, 0, y)
      }, 0)
    }
  }

  function wireResult() {
    Array.prototype.forEach.call(document.querySelectorAll("#wdff-result .wdff-por__b"), function(b) {
      b.addEventListener("click", function() {
        var v = Number(b.getAttribute("data-por"));
        if (CFG.SHARES.indexOf(v) === -1) return;
        try {
          window.wynProfile && window.wynProfile.set ? window.wynProfile.set({
            portion: v
          }) : (function() {
            var d = JSON.parse(localStorage.getItem("wyn_dog") || "{}") || {};
            d.portion = v, d.updated = Date.now(), localStorage.setItem("wyn_dog", JSON.stringify(d))
          })()
        } catch (e) {}
        rerunQuiet()
      })
    });
    var redo = $("wdff-redo");
    redo && redo.addEventListener("click", function() {
      $("wdff-result").hidden = !0, $("wdff-form").hidden = !1, scrollTo($("wdff-form"))
    });
    var ast = $("wdff-ast"),
      tip = $("wdff-tip");
    ast && tip && ast.addEventListener("click", function() {
      tip.hidden = !tip.hidden
    });
    var cart = $("wdff-cart");
    cart && cart.addEventListener("click", function() {
      var btn = this,
        pack = packWeek(Number(btn.getAttribute("data-oz")), btn.getAttribute("data-key"));
      if (pack) {
        btn.disabled = !0, btn.querySelector(".wdff-cart__t").innerHTML = COPY.cart_adding;
        var TV = window.themeVariables || {},
          routes = TV.routes || {},
          addUrl = (routes.cartAddUrl || CFG.CART_ADD_URL) + ".js",
          getUrl = (routes.cartUrl || CFG.CART_GET_URL) + ".js",
          drawer = TV.settings && TV.settings.cartType === "drawer";
        fetch(addUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: pack.items.map(function(i) {
              return {
                id: i.id,
                quantity: i.qty
              }
            }),
            attributes: {
              Source: CFG.CART_SOURCE
            }
          })
        }).then(function(r) {
          if (!r.ok) throw new Error("add HTTP " + r.status);
          return fetch(getUrl)
        }).then(function(r) {
          if (!r.ok) throw new Error("get HTTP " + r.status);
          return r.json()
        }).then(function(freshCart) {
          var d = document.documentElement;
          d.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: !0,
            detail: {
              cart: freshCart
            }
          })), d.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: !0,
            detail: {
              cart: freshCart,
              openMiniCart: CFG.OPEN_MINICART && drawer
            }
          })), btn.querySelector(".wdff-cart__t").innerHTML = COPY.cart_added, btn.classList.add("is-done")
        }).catch(function(err) {
          btn.disabled = !1, btn.querySelector(".wdff-cart__t").innerHTML = COPY.cart_err, window.console && console.warn("[Wynwood diet finder] cart add: " + err.message)
        })
      }
    })
  }

  function showError(err) {
    var h = '<p class="wdff-err">' + COPY.err_load + "</p>";
    if (window.Shopify && window.Shopify.designMode) {
      var reason = err && err.message ? esc(err.message) : "Unknown error",
        url = dataURL();
      h += '<p class="wdff-err wdff-err--admin">' + fill(COPY.err_admin, {
        reason: reason
      }) + (url ? '<br><span class="wdff-err__url">' + esc(url) + "</span>" : '<br><span class="wdff-err__url">No URL set.</span>') + "</p>"
    }
    body.innerHTML = h
  }

  /* A SMALL DOOR FOR THE SECTION'S OWN SCRIPTS (2026-11-01): read the answers,
     set the age, and run the plan again (the dog picked at the end can have a
     birthday that puts it in a different age band). Weight is still set through
     the slider, so the display and the answer can never disagree. */
  window.wdffFinder = {
    v: "2026-11-01b",
    rerunning: !1,
    share: savedShare,
    answers: function() {
      return {
        weight: state.weight,
        age: state.age,
        months: ageMonths(),
        body: state.body,
        act: state.act,
        cond: state.cond
      }
    },
    ageOptionFor: ageOptionFor,
    setAge: function(months) {
      var o = ageOptionFor(months),
        sel = $("wdff-age");
      if (o == null) return null;
      return state.age = o, sel && (sel.value = String(o)), checkReady(), o
    },
    ready: function() {
      return !!$("wdff-form")
    },
    run: function() {
      var go = $("wdff-go");
      return !(!go || go.disabled) && (go.click(), !0)
    }
  };

  function mount() {
    mounted || (mounted = !0, body.innerHTML = '<p class="wdff-loading">' + COPY.loading + "</p>", WynwoodDiets.load().then(function(db) {
      DB = db, body.innerHTML = formHTML(), wireForm()
    }).catch(function(err) {
      showError(err), window.console && (console.warn("[Wynwood diet finder] " + err.message), console.warn("[Wynwood diet finder] URL tried: " + (dataURL() || "(none set)")))
    }))
  }
  root.addEventListener("toggle", function() {
    root.open && mount()
  }), root.open && mount()
})();